const i18n = {
  'en-US': {
    'menu.welcome': 'Welcome',
    'menu.dashboard': 'Dashboard',
    'menu.list': 'List',
    'menu.result': 'Result',
    'menu.exception': 'Exception',
    'menu.form': 'Form',
    'menu.profile': 'Profile',
    'menu.visualization': 'Data Visualization',
    'menu.user': 'User Center',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.profile.basic': 'Basic Profile',
    'menu.list.cardList': 'Card List',
    'menu.visualization.dataAnalysis': 'Analysis',
    'menu.result.error': 'Error',
    'menu.form.group': 'Group Form',
    'menu.dashboard.monitor': 'Real-time Monitor',
    'menu.visualization.multiDimensionDataAnalysis': 'Multi-D Analysis',
    'menu.list.searchTable': 'Search Table',
    'menu.form.step': 'Step Form',
    'menu.result.success': 'Success',
    'menu.user.info': 'User Info',
    'menu.user.setting': 'User Setting',
    'menu.user.switchRoles': 'Switch Roles',
    'menu.user.role.admin': 'Admin',
    'menu.user.role.user': 'General User',
    'menu.dashboard.workplace': 'Workplace',
    'navbar.logout': 'Logout',
    'settings.title': 'Settings',
    'settings.themeColor': 'Theme Color',
    'settings.content': 'Content Setting',
    'settings.navbar': 'Navbar',
    'settings.menuWidth': 'Menu Width (px)',
    'settings.navbar.theme.toLight': 'Click to use light mode',
    'settings.navbar.theme.toDark': 'Click to use dark mode',
    'settings.menu': 'Menu',
    'settings.footer': 'Footer',
    'settings.otherSettings': 'Other Settings',
    'settings.colorWeek': 'Color Week',
    'settings.alertContent': 'After the configuration is only temporarily effective, if you want to really affect the project, click the "Copy Settings" button below and replace the configuration in settings.json.',
    'settings.copySettings': 'Copy Settings',
    'settings.copySettings.message': 'Copy succeeded, please paste to file src/settings.json.',
    'settings.close': 'Close',
    'settings.color.tooltip': '10 gradient colors generated according to the theme color',
    'message.tab.title.message': 'Message',
    'message.tab.title.notice': 'Notice',
    'message.tab.title.todo': 'ToDo',
    'message.allRead': 'All Read',
    'message.seeMore': 'SeeMore',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to ',
    'navbar.search.placeholder': 'Please search'
  },
  'zh-CN': {
    'menu.welcome': '欢迎',
    'menu.dashboard': '仪表盘',
    'menu.list': '列表页',
    'menu.result': '结果页',
    'menu.exception': '异常页',
    'menu.form': '表单页',
    'menu.profile': '详情页',
    'menu.visualization': '数据可视化',
    'menu.user': '个人中心',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.profile.basic': '基础详情页',
    'menu.list.cardList': '卡片列表',
    'menu.visualization.dataAnalysis': '分析页',
    'menu.result.error': '失败页',
    'menu.form.group': '分组表单',
    'menu.dashboard.monitor': '实时监控',
    'menu.visualization.multiDimensionDataAnalysis': '多维数据分析',
    'menu.list.searchTable': '查询表格',
    'menu.form.step': '分步表单',
    'menu.result.success': '成功页',
    'menu.user.info': '用户信息',
    'menu.user.setting': '用户设置',
    'menu.user.switchRoles': '切换角色',
    'menu.user.role.admin': '管理员',
    'menu.user.role.user': '普通用户',
    'menu.dashboard.workplace': '工作台',
    'navbar.logout': '退出登录',
    'settings.title': '页面配置',
    'settings.themeColor': '主题色',
    'settings.content': '内容区域',
    'settings.navbar': '导航栏',
    'settings.menuWidth': '菜单宽度 (px)',
    'settings.navbar.theme.toLight': '点击切换为亮色模式',
    'settings.navbar.theme.toDark': '点击切换为暗黑模式',
    'settings.menu': '菜单栏',
    'settings.footer': '底部',
    'settings.otherSettings': '其他设置',
    'settings.colorWeek': '色弱模式',
    'settings.alertContent': '配置之后仅是临时生效，要想真正作用于项目，点击下方的 "复制配置" 按钮，将配置替换到 settings.json 中即可。',
    'settings.copySettings': '复制配置',
    'settings.copySettings.message': '复制成功，请粘贴到 src/settings.json 文件中',
    'settings.close': '关闭',
    'settings.color.tooltip': '根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）',
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 ',
    'navbar.search.placeholder': '输入内容查询',
    'menu.channel': "渠道管理",
    'menu.channel.list': "渠道列表",
    'menu.channel.add': '新增渠道',
    'menu.customer': '客户管理',
    'menu.customer.list': '客户列表',
    'menu.customer.detail': '客户详情',
    'menu.customer.add': '新增客户',
    'menu.customer.edit': '编辑客户',
    'menu.customer.delete': '删除客户',
    'menu.customer.import': '导入客户',
    'menu.customer.brand': '品牌管理',
    'menu.customer.brand.list': '品牌列表',
    'menu.customer.brand.add': '新增品牌',
    'menu.customer.brand.result': '新增品牌结果',
    'menu.customer.brand.edit': '编辑品牌',
    'menu.customer.brand.delete': '删除品牌',
    'menu.customer.store': '门店管理',
    'menu.customer.store.list': '门店列表',
    'menu.customer.store.add': '新增门店',
    'menu.customer.store.result': '新增门店结果',
    'menu.customer.store.edit': '编辑门店',
    'menu.customer.store.delete': '删除门店',
    'menu.customer.store.data-analysis': '门店数据分析',
    'menu.cards': "碰碰卡管理",
    'menu.cards.list': '碰碰卡列表',
    'menu.cards.add': '碰碰卡开通',
    'menu.cards.edit': '编辑碰碰卡',
    'menu.cards.delete': '删除碰碰卡',
    'menu.cards.import': '导入碰碰卡',
    'menu.cards.result': '卡片开卡结果',
    'menu.material.add.result': '素材添加结果',
    'menu.material': "卡片内容管理",
    'menu.material.video.list': '视频内容列表',
    'menu.material.add': '新增内容',
    'menu.material.edit': '编辑内容',
    'menu.material.delete': '删除内容',
    'menu.material.import': '导入内容',
    'menu.material.add.video': '视频内容',
    'menu.material.video.edit': '编辑视频内容',
    'menu.material.video.delete': '删除视频内容',
    'menu.material.video.import': '导入视频内容',
    'menu.material.note.list': "笔记素材列表",
    'menu.material.note.add': '新增笔记素材',
    'menu.material.add.image': '图片内容',
    'menu.material.image.edit': '编辑图片内容',
    'menu.material.image.delete': '删除图片内容',
    'menu.material.image.import': '导入图片内容',
    'menu.video-cut': "内容生成",
    'menu.video-cut.material': '剪辑素材',
    'menu.video-cut.cut': '智能混剪',
    'menu.video-cut.template-cut': '模版剪辑',
    'menu.video-cut.template-cut.list': '任务列表',
    'menu.video-cut.template-cut.add': '创建任务',
    'menu.video-cut.template-cut.edit': '编辑任务',
    'menu.video-cut.template-cut.delete': '删除任务',
    'menu.video-cut.template-cut.detail': '任务详情',
    'menu.video-cut.template-cut.audit': '审核发布',
    'menu.video-cut.result': '剪辑结果',
    'menu.video-cut.template': '剪辑模板',
    'menu.video-cut.template.list': '模板列表',
    'menu.video-cut.material.video': '视频素材',
    'menu.video-cut.material.video.add': '新增视频素材',
    'menu.video-cut.material.video.detail': '视频素材管理',
    'menu.video-cut.material.image': '图片素材',
    'menu.video-cut.material.image.add': '新增图片素材',
    'menu.video-cut.material.audio': '音频素材',
    'menu.video-cut.material.audio.add': '新增音频素材',
    'menu.video-cut.cut.add': '脚本混剪',
    'menu.video-cut.cut.ai': '智能混剪',
    'menu.video-cut.cut.list': '任务列表',
    'menu.video-cut.cut.detail': '任务详情',
    'menu.video-cut.cut.audit': '审核发布',
    'menu.video-cut.note': '创意笔记',
    'menu.video-cut.note.add': '笔记生成',
    'menu.weixin': "微信管理",
    'menu.weixin.bind.list': '微信绑定列表',
    'menu.creative': "创意中心",
    'menu.creative.list': '创意列表',
    'menu.creative.add': '新增创意',
    'menu.creative.edit': '编辑创意',
    'menu.creative.delete': '删除创意',
    'menu.creative.import': '导入创意',
    'menu.creative.editing-script': '剪辑脚本',
    'menu.creative.editing-script.add': '新增剪辑脚本',
    'menu.creative.editing-script.edit': '编辑剪辑脚本',
    'menu.creative.editing-script.delete': '删除剪辑脚本',
    'menu.creative.ai-video': 'AI视频',
    'menu.creative.ai-video.add': '新增图生视频',
    'menu.creative.ai-image': "AI生图",
    'menu.creative.ai-image.add': '新增AI生图',
    'menu.creative.ai-model': 'AI模特',
    'menu.creative.ai-model.add': '创建AI模特',
    "menu.creative.ai-crossdress": "AI换装",
    "menu.creative.ai-crossdress.add": "创建AI换装",
    "menu.creative.ai-tts": "AI音色",
    "menu.creative.ai-tts.add": "创建AI音频",
    "menu.creative.ai-audio": "AI音乐",
    "menu.creative.ai-audio.add": "创建AI音乐",
    "menu.creative.ai-human": "AI数字人",
    "menu.creative.ai-human.add": "创建AI数字人"
  }
};
export default i18n;